import {
  Box,
  TextField,
  IconButton,
  makeStyles
} from "@material-ui/core";
import { ArrowUpward, InfoSharp } from "@material-ui/icons";
import { observer } from "mobx-react";
import { useState, useRef, useEffect } from "react";
import { InformationButtonMenu } from "./informationButtonMenu";
import { ChatBotStore } from "../../stores/chatBotStore";

const useStyles = makeStyles((theme) => ({
  container: {
    border: "2px solid #c7d2fe",
    borderRadius: 20,
    padding: "0px 10px",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
    backgroundColor: "#f9fafb",
    width: "100%",
  },
  textField: {
    "& .MuiInputBase-root": {
      color: "#4c5d9b",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },
  bottomRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "5px 0px",
  },
  leftButton: {
    backgroundColor: '#A4E0E9',
    color: theme.palette.common.white,
    borderRadius: 20,
    padding: 6,
    "&:hover": {
      backgroundColor: "#6FBCC6",
    },
  },
  rightButton: {
    backgroundColor: '#2D4558',
    color: theme.palette.common.white,
    borderRadius: 20,
    "&:hover": {
      backgroundColor: "#1e2a44",
    },
  },
}));

interface TextAreaProps {
  value: string;
  setValue: (value: string) => void;
  onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  handleSend: () => void;
  store: ChatBotStore;
}
export const ChatBotTextArea = observer(({ value, setValue, onKeyPress, disabled, handleSend, store }: TextAreaProps) => {
  const classes = useStyles();

  useEffect(() => {
    const fetchInformationOptions = async () => {
      await store.getInformationOptions();
    }
    fetchInformationOptions();
  }, []);


  return (
    <>
      <Box className={classes.container}>
        <TextField
          placeholder="What are you looking for?"
          multiline
          fullWidth
          value={value}
          onKeyPress={onKeyPress}
          onChange={(e) => setValue(e.target.value)}
          variant="outlined"
          className={classes.textField}
          minRows={1}
          maxRows={4}
          disabled={disabled}
        />

        <Box className={classes.bottomRow}>
          <InformationButtonMenu store={store} />
          <IconButton className={classes.rightButton} size="small" onClick={handleSend}>
            <ArrowUpward fontSize="medium" />
          </IconButton>
        </Box>
      </Box>

    </>
  );
});